<!-- OutOfStockPopup2.svelte -->
<script>
  console.log('OutOfStockPopup2 component initialized');
  export let onClose;
  export let error;

  let unavailableItems = [];

  $: {
    if (error && error.error) {
      try {
        const parsedError = JSON.parse(error.error.replace(/'/g, '"'));
        unavailableItems = [];
        for (let i = 0; i < parsedError.unavailable_items.length; i += 5) {
          unavailableItems.push({
            productId: parsedError.unavailable_items[i],
            title: parsedError.unavailable_items[i + 1],
            reason: parsedError.unavailable_items[i + 2],
            quantityAvailable: parsedError.unavailable_items[i + 3],
            quantityRequested: parsedError.unavailable_items[i + 4]
          });
        }
      } catch (e) {
        console.error('Error parsing unavailable items:', e);
      }
    }
  }
</script>

<div class="popup-overlay">
  <div class="popup-content">
    <h2>Unavailable Items</h2>
    <p>We're sorry, but the following items are currently unavailable:</p>
    <ul>
      {#each unavailableItems as item}
        <li>
          <strong>{item.title}</strong>
          <span class="reason">{item.reason}</span>
          {#if item.reason === 'Insufficient quantity'}
            <span class="quantity">Available: {item.quantityAvailable}, Requested: {item.quantityRequested}</span>
          {/if}
        </li>
      {/each}
    </ul>
    <button class="close-button" on:click={onClose}>Okay</button>
  </div>
</div>

<style>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .popup-content {
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 400px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  h2 {
    font-size: 24px;
    margin-bottom: 16px;
    color: #333;
  }

  p {
    margin-bottom: 16px;
    color: #666;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin-bottom: 24px;
  }

  li {
    margin-bottom: 12px;
    padding: 12px;
    background-color: #f8f8f8;
    border-radius: 4px;
  }

  .reason {
    display: block;
    font-size: 14px;
    color: #e53935;
    margin-top: 4px;
  }

  .quantity {
    display: block;
    font-size: 14px;
    color: #666;
    margin-top: 4px;
  }

  .close-button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
  }

  .close-button:hover {
    background-color: #45a049;
  }
</style>


